// SettingsLayout — pushes <SettingsNav /> into the SidebarContext for
// the Settings module's route subtree, then renders <Outlet />.
//
// Same nav-injection pattern as WeighbridgeLayout / SkipLayout.
// No subscription gate, no extra context providers needed.

import { Outlet } from 'react-router-dom';
import { useSidebarContent } from '../../components/shell/SidebarContext';
import { SettingsNav } from './SettingsNav';

const SETTINGS_NAV = <SettingsNav />;

export function SettingsLayout() {
  useSidebarContent(SETTINGS_NAV);
  return <Outlet />;
}
